/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * DashBoard
 * OpenAPI spec version: v2.0.0
 */

export type CsvFilterOperator =
  (typeof CsvFilterOperator)[keyof typeof CsvFilterOperator];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CsvFilterOperator = {
  Equal: 'Equal',
  NotEqual: 'NotEqual',
  GreaterThan: 'GreaterThan',
  GreaterThanOrEqual: 'GreaterThanOrEqual',
  LessThan: 'LessThan',
  LessThanOrEqual: 'LessThanOrEqual',
  Contains: 'Contains',
  StartsWith: 'StartsWith',
  EndsWith: 'EndsWith',
} as const;
